import { StyleSheet } from 'react-native';
import theme from '@/config/theme';

export const styles = StyleSheet.create({
  list: {
    padding: theme.spacings.sm,
  },
});
